import { generateTypes } from '../../utils/HttpReducerHelper';

const updateTeamRole = generateTypes('TEAMS', 'UPDATE_TEAM_ROLE');

export { updateTeamRole };
